module.exports = __webpack_public_path__ + "img/header-diamondJewelryExclusive.3cff4e7.webp";